const sessionSaverMiddleware = store => next => action => {
    next(action);
    const { currentUser } = store.getState();
    localStorage.setItem('reduxState', JSON.stringify({ currentUser }));
};

export default sessionSaverMiddleware;
